import { useCallback } from 'react';
import { saveDefaultFundingAmount } from '../../../../wallet/utilities/api';

const useSaveWalletDefaultFundingAmount = (walletId) => {
  return useCallback(
    (amount) => {
      return saveDefaultFundingAmount(walletId, amount);
    },
    [walletId],
  );
};

export default useSaveWalletDefaultFundingAmount;
